//markedRecipeService.jsx
import { t } from "i18next";
import { apiRequest } from "./apiService";

const markedRecipesUrl = process.env.REACT_APP_DB_URL + "/markedRecipes";

export const fetchMarkedRecipes = async (userId) => {
  if (!userId) return [];

  return await apiRequest(`${markedRecipesUrl}/${userId}.json`);
};

export const updateMarkedRecipes = async (userId, markedRecipes) => {
  if (!userId) {
    throw new Error(t("errors.userNotAuthenticated"));
  }

  return await apiRequest(`${markedRecipesUrl}/${userId}.json`, "PUT", markedRecipes);
};
